var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobotSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 108,
    viewBox: "0 0 97 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8281 87.4962C25.2345 90.878 28.4019 89.9313 30.7912 93.2407C31.0655 93.6204 32.4663 95.5621 32.1862 98.054C31.9625 100.04 30.7615 101.572 30.006 102.246C25.4133 106.34 12.7757 101.331 5.53812 95.8533C3.96024 94.6588 -0.273648 91.4551 0.579071 89.1793C0.928546 88.2471 2.01367 87.7837 2.79241 87.463C6.23532 86.0449 9.80638 86.9862 11.8281 87.4962Z",
    fill: "url(#paint0_linear_33918_141597)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2205 4.51562H50.3671V21.7586H53.2205V4.51562Z",
    fill: "url(#paint1_linear_33918_141597)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6472 31.2843H41.9403C40.4871 31.2843 39.3093 30.1998 39.3093 28.8616V22.3759C39.3093 21.0376 40.4871 19.9531 41.9403 19.9531H61.6472C63.1004 19.9531 64.2781 21.0376 64.2781 22.3759V28.8616C64.2776 30.1998 63.0998 31.2843 61.6472 31.2843Z",
    fill: "url(#paint2_linear_33918_141597)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4662 68.9753C96.4662 79.4504 87.2442 87.9426 75.8688 87.9426H27.7187C16.3899 87.9426 7.12122 79.4075 7.12122 68.9753V59.1223C7.12122 40.5615 23.6124 25.375 43.7689 25.375H59.8191C79.9751 25.375 96.4668 40.561 96.4668 59.1223L96.4662 68.9753Z",
    fill: "url(#paint3_linear_33918_141597)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9423 77.605C63.3527 73.6877 55.9051 71.9992 52.5794 71.9992C48.9765 71.9992 42.124 73.2333 40.385 76.9181C42.1224 76.3692 42.0479 77.6047 43.1565 77.6047C44.265 77.6047 48.378 76.5293 51.7479 76.6209C54.4724 76.6949 58.6765 77.6047 58.6765 77.6047C59.818 78.0039 62.5056 75.8991 63.9423 77.605Z",
    fill: "url(#paint4_linear_33918_141597)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.869 77.0462C63.6766 75.9953 62.5475 75.2626 61.2394 75.2625L43.1621 75.2578C41.8547 75.2577 40.6346 75.9885 40.3121 77.0394C40.1685 77.5064 40.0647 77.9844 40.0032 78.4726C39.9863 78.6072 40.037 78.7391 40.1447 78.8378C40.2524 78.9357 40.4064 78.991 40.5715 78.9915L63.3776 78.9981C63.5404 78.9982 63.6985 78.9435 63.8165 78.8471C63.9345 78.7507 64.0003 78.6205 64 78.4878C64 77.9962 63.955 77.5151 63.869 77.0462Z",
    fill: "#EEFDFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4132 67.1776C81.2442 67.7097 79.9336 67.9886 78.6021 67.9886H24.9857C23.6542 67.9886 22.3437 67.7097 21.1747 67.1776C18.3031 65.8705 16.6827 63.231 17.0881 60.5235L17.1178 60.3266C18.4919 51.1554 27.5118 44.1044 38.5704 43.5745C43.2492 43.3503 48.1594 43.2344 53.2809 43.2618C57.2929 43.2832 61.1709 43.3916 64.9051 43.5686C76.0055 44.0953 85.0919 51.1184 86.4712 60.3245C86.4811 60.3905 86.491 60.457 86.5009 60.5229C86.9057 63.231 85.2847 65.8705 82.4132 67.1776Z",
    fill: "url(#paint5_linear_33918_141597)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6633 65.968C43.2471 65.968 47.7736 61.7997 47.7736 56.6578C47.7736 51.516 43.2471 47.3477 37.6633 47.3477C32.0795 47.3477 27.553 51.516 27.553 56.6578C27.553 61.7997 32.0795 65.968 37.6633 65.968Z",
    fill: "url(#paint6_radial_33918_141597)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6635 63.3416C41.6713 63.3416 44.9203 60.3497 44.9203 56.6591C44.9203 52.9684 41.6713 49.9766 37.6635 49.9766C33.6556 49.9766 30.4066 52.9684 30.4066 56.6591C30.4066 60.3497 33.6556 63.3416 37.6635 63.3416Z",
    fill: "#EEFDFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6636 62.2758C41.0297 62.2758 43.7584 59.763 43.7584 56.6633C43.7584 53.5636 41.0297 51.0508 37.6636 51.0508C34.2975 51.0508 31.5687 53.5636 31.5687 56.6633C31.5687 59.763 34.2975 62.2758 37.6636 62.2758Z",
    fill: "url(#paint7_linear_33918_141597)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5676 55.2C41.5676 56.3484 40.557 57.279 39.31 57.279C38.0629 57.279 37.0524 56.3478 37.0524 55.2C37.0524 54.0522 38.0629 53.1211 39.31 53.1211C40.557 53.1211 41.5676 54.0522 41.5676 55.2Z",
    fill: "#EEFDFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7625 61.7884C37.2602 61.7884 37.6636 61.4169 37.6636 60.9587C37.6636 60.5004 37.2602 60.1289 36.7625 60.1289C36.2649 60.1289 35.8615 60.5004 35.8615 60.9587C35.8615 61.4169 36.2649 61.7884 36.7625 61.7884Z",
    fill: "#EEFDFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5283 59.7154C34.5283 59.9444 34.3268 60.13 34.0781 60.13C33.8293 60.13 33.6278 59.9444 33.6278 59.7154C33.6278 59.4864 33.8293 59.3008 34.0781 59.3008C34.3268 59.3008 34.5283 59.4869 34.5283 59.7154Z",
    fill: "#EEFDFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9755 65.968C70.5593 65.968 75.0859 61.7997 75.0859 56.6578C75.0859 51.516 70.5593 47.3477 64.9755 47.3477C59.3918 47.3477 54.8652 51.516 54.8652 56.6578C54.8652 61.7997 59.3918 65.968 64.9755 65.968Z",
    fill: "url(#paint8_radial_33918_141597)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9754 63.3416C68.9832 63.3416 72.2322 60.3497 72.2322 56.6591C72.2322 52.9684 68.9832 49.9766 64.9754 49.9766C60.9675 49.9766 57.7185 52.9684 57.7185 56.6591C57.7185 60.3497 60.9675 63.3416 64.9754 63.3416Z",
    fill: "#EEFDFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9752 62.2758C68.3413 62.2758 71.0701 59.763 71.0701 56.6633C71.0701 53.5636 68.3413 51.0508 64.9752 51.0508C61.6091 51.0508 58.8804 53.5636 58.8804 56.6633C58.8804 59.763 61.6091 62.2758 64.9752 62.2758Z",
    fill: "url(#paint9_linear_33918_141597)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8805 55.2C68.8805 56.3484 67.8694 57.279 66.6229 57.279C65.3765 57.279 64.3647 56.3478 64.3647 55.2C64.3647 54.0522 65.3759 53.1211 66.6229 53.1211C67.87 53.1211 68.8805 54.0522 68.8805 55.2Z",
    fill: "#EEFDFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0747 61.7884C64.5723 61.7884 64.9757 61.4169 64.9757 60.9587C64.9757 60.5004 64.5723 60.1289 64.0747 60.1289C63.577 60.1289 63.1736 60.5004 63.1736 60.9587C63.1736 61.4169 63.577 61.7884 64.0747 61.7884Z",
    fill: "#EEFDFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8407 59.7154C61.8407 59.9444 61.6391 60.13 61.3904 60.13C61.1417 60.13 60.9402 59.9444 60.9402 59.7154C60.9402 59.4864 61.1417 59.3008 61.3904 59.3008C61.6391 59.3008 61.8407 59.4869 61.8407 59.7154Z",
    fill: "#EEFDFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4495 3.36674C55.4495 5.22577 53.8128 6.73349 51.7934 6.73349C49.7746 6.73349 48.1379 5.22631 48.1379 3.36674C48.1379 1.50771 49.7746 0 51.7934 0C53.8128 0 55.4495 1.50718 55.4495 3.36674Z",
    fill: "url(#paint10_linear_33918_141597)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3351 2.05394C54.3351 2.62087 53.836 3.08 53.2203 3.08C52.6046 3.08 52.1055 2.62034 52.1055 2.05394C52.1055 1.48701 52.6046 1.02734 53.2203 1.02734C53.836 1.02788 54.3351 1.48701 54.3351 2.05394Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2723 36.1688C83.3206 37.7403 81.9274 39.6203 80.3314 39.7807C78.8357 39.9314 77.641 38.524 76.4091 37.0726C75.1947 35.6421 72.5393 31.9669 73.5971 30.9275C74.9909 29.5571 83.1575 32.4609 83.2723 36.1688Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M69.607 30.1795C70.3086 30.1795 70.8774 29.6557 70.8774 29.0096C70.8774 28.3636 70.3086 27.8398 69.607 27.8398C68.9054 27.8398 68.3367 28.3636 68.3367 29.0096C68.3367 29.6557 68.9054 30.1795 69.607 30.1795Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0913 57.9683C82.6836 58.2333 79.8418 52.9018 72.2127 48.2795C69.5311 46.6543 66.8838 45.4963 67.0411 45.1594C67.2007 44.8178 70.1823 45.4534 72.5692 46.473C80.175 49.7223 83.5759 57.6535 83.0913 57.9683Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5555 23.3069C63.4647 23.3187 63.4064 22.8269 62.9614 22.0669C62.9614 22.0669 62.7535 21.7113 62.5158 21.4098C61.7499 20.439 59.1533 20.4605 58.9495 20.4621C54.9054 20.4943 52.3054 20.2583 52.3065 20.2808C52.3071 20.2996 54.2036 20.2642 55.5933 20.2384C59.5139 20.1649 61.8495 19.9708 62.8508 20.9378C63.2661 21.339 63.4751 21.8614 63.4751 21.8614C63.7582 22.5705 63.6639 23.2925 63.5555 23.3069Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8164 99.682C83.8164 99.7952 83.8164 99.9036 83.8112 100.007C83.7687 101.042 83.506 101.82 83.3778 102.17C79.6915 112.54 77.4822 118.009 74.3847 122.433C73.85 123.197 73.2879 123.93 72.6833 124.65C71.8918 125.61 71.0251 126.546 70.0617 127.512C67.9217 129.656 64.685 130.626 63.6418 130.961C59.8273 132.203 56.4566 131.976 54.2153 131.996H53.8245C51.5774 131.976 48.2125 132.203 44.398 130.961C43.3548 130.626 40.1128 129.656 37.9781 127.512C32.093 121.615 29.8301 116.713 24.662 102.17C24.5391 101.835 24.2927 101.11 24.2339 100.14C24.2181 99.859 24.2123 99.5785 24.2286 99.2975C24.341 97.5586 25.1058 95.8535 26.4653 94.297C28.7928 91.627 32.3877 90.1638 36.1061 90.1487L54.0231 90.0796L71.6139 90.0157C75.4127 90.0007 79.0933 91.4693 81.5058 94.1736C82.6725 95.4839 83.4157 96.8978 83.6889 98.3562C83.7261 98.5632 83.7582 98.775 83.7797 98.9821C83.8001 99.2138 83.8164 99.4455 83.8164 99.682Z",
    fill: "url(#paint11_linear_33918_141597)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0192 90.0796L36.1022 90.1487C32.3838 90.1638 28.7889 91.627 26.4614 94.297C25.1025 95.854 24.3377 97.5586 24.2247 99.2975C24.3156 97.5141 25.113 95.765 26.5307 94.1736C28.938 91.4687 32.6244 90.0007 36.4226 90.0157L54.0192 90.0796Z",
    fill: "url(#paint12_linear_33918_141597)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8275 114.389C71.566 101.591 69.6852 99.0601 72.4589 96.0157C72.7775 95.666 74.4043 93.8805 77.0795 93.4246C79.2113 93.0614 81.1462 93.6901 82.0618 94.1674C87.6232 97.0686 85.9731 109.647 82.3094 117.587C81.5108 119.318 79.368 123.963 76.7562 123.852C75.6862 123.806 74.897 122.978 74.3437 122.381C71.8944 119.74 71.8671 116.319 71.8275 114.389Z",
    fill: "url(#paint13_linear_33918_141597)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3844 122.435C73.8497 123.198 73.2876 123.932 72.683 124.651C72.4902 124.469 72.319 124.287 72.164 124.119C69.7136 121.479 69.6868 118.06 69.6496 116.129C69.3875 103.329 67.5044 100.802 70.281 97.7572C70.4842 97.5308 71.228 96.7177 72.4372 96.043C69.6979 99.0777 71.5653 101.63 71.8274 114.39C71.8647 116.321 71.8967 119.74 74.3418 122.386C74.3576 122.4 74.3739 122.415 74.3844 122.435Z",
    fill: "url(#paint14_linear_33918_141597)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M82.227 103.735C82.1483 102.359 81.8682 101.348 81.3078 99.3251C80.5751 96.6787 79.656 95.3888 80.253 94.8776C80.6415 94.5451 81.4069 94.7698 81.5805 94.8207C84.2073 95.5926 85.0205 100.131 84.9075 102.971C84.8381 104.71 84.3774 106.654 83.6854 106.74C83.5765 106.753 83.3051 106.74 83.1111 106.582C82.3388 105.954 82.287 104.78 82.227 103.735Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33918_141597",
    x1: 19.458,
    y1: 95.2769,
    x2: 68.1514,
    y2: 136.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#59BBD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33918_141597",
    x1: 45.9786,
    y1: 13.918,
    x2: 54.5069,
    y2: 12.5674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#AAE5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33918_141597",
    x1: 43.795,
    y1: 33.9347,
    x2: 57.5991,
    y2: 17.0099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#91DDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_33918_141597",
    x1: 21.7925,
    y1: 88.6436,
    x2: 77.0367,
    y2: 28.6514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#B1EFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_33918_141597",
    x1: 48.1719,
    y1: 75.2494,
    x2: 63.5067,
    y2: 97.6321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0714,
    stopColor: "#4FA6AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_33918_141597",
    x1: 51.6354,
    y1: 67.9086,
    x2: 52.0891,
    y2: 45.7373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2F45"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_33918_141597",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6631 56.6578) scale(10.0057 9.21383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1296,
    stopColor: "#3280FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_33918_141597",
    x1: 31.5683,
    y1: 56.6632,
    x2: 43.7584,
    y2: 56.6632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2F45"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_33918_141597",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.9754 56.6578) scale(10.0057 9.21383)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1296,
    stopColor: "#3280FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_33918_141597",
    x1: 58.88,
    y1: 56.6632,
    x2: 71.0702,
    y2: 56.6632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_33918_141597",
    x1: 44.0979,
    y1: 4.39999,
    x2: 55.3842,
    y2: 2.61259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#99DFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_33918_141597",
    x1: 34.9672,
    y1: 125.221,
    x2: 76.8165,
    y2: 72.1518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64CEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#64CEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#7DD5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8004,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_33918_141597",
    x1: 32.5206,
    y1: 100.463,
    x2: 57.6872,
    y2: 68.5489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_33918_141597",
    x1: 92.1881,
    y1: 117.806,
    x2: 59.647,
    y2: 91.9604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0734,
    stopColor: "#9CE4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8955,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_33918_141597",
    x1: 61.7189,
    y1: 115.55,
    x2: 85.3183,
    y2: 102.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotSad);
export default __webpack_public_path__ + "static/media/robot-sad.524d0cb3.svg";
export { ForwardRef as ReactComponent };